module.exports = __webpack_public_path__ + "img/price_header_en.c12e833a.svg";